module.exports = __webpack_public_path__ + "img/emoji-icon.d82a9f6b.svg";